// extracted by mini-css-extract-plugin
module.exports = {"blogDesignCta":"TrendsBlogsCta_blogDesignCta__c0uv4","head":"TrendsBlogsCta_head__4KXOw","bgCta":"TrendsBlogsCta_bgCta__n4u3m"};